// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1v5Hx","list":"PatternAutocomplete_list__1sJqa"};